/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ImageUploadContent, MediaUploadData } from '../../../../models';

@Component({
  selector: 'ptl-media-upload-image-preview',
  templateUrl: './media-upload-image-preview.component.html',
  styleUrls: ['./media-upload-image-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaUploadImagePreviewComponent {
  /** Receives image upload data */
  @Input() uploadedImage: MediaUploadData | undefined;
  @Input() link: string | undefined;
  @Input() caption: string | undefined;
  @Input() collage = false;

  @Output() openUrl = new EventEmitter();

  private readonly cdr = inject(ChangeDetectorRef);

  originalUrl = '';
  /** The file behind this block is gone (the placeholder is showing), so the link on it must not fire. */
  unavailable = false;

  get url(): string {
    if (!this.uploadedImage) {
      return '';
    }

    const content = this.uploadedImage.content as ImageUploadContent;
    this.originalUrl = content.original;
    switch (this.uploadedImage.position) {
      case 'THUMBNAIL':
      case 'LEFT':
      case 'RIGHT':
        return content.original;
      case 'CENTER':
        return content.original;
      case 'FULL_WIDTH':
        return content.extraLarge;
      default:
        return content.original;
    }
  }

  onUnavailable() {
    this.unavailable = true;
    this.cdr.markForCheck();
  }

  onImageClick() {
    if (this.link && !this.unavailable) {
      this.openUrl.emit();
    }
  }
}
